import { render, staticRenderFns } from "./c_set_up.vue?vue&type=template&id=19f557cd&scoped=true"
import script from "./c_set_up.vue?vue&type=script&lang=js"
export * from "./c_set_up.vue?vue&type=script&lang=js"
import style0 from "./c_set_up.vue?vue&type=style&index=0&id=19f557cd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f557cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f557cd')) {
      api.createRecord('19f557cd', component.options)
    } else {
      api.reload('19f557cd', component.options)
    }
    module.hot.accept("./c_set_up.vue?vue&type=template&id=19f557cd&scoped=true", function () {
      api.rerender('19f557cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_set_up.vue"
export default component.exports